import { render, staticRenderFns } from "./video-player-sm.vue?vue&type=template&id=1145581b&scoped=true"
import script from "./video-player-sm.vue?vue&type=script&lang=tsx"
export * from "./video-player-sm.vue?vue&type=script&lang=tsx"
import style0 from "./video-player-sm.vue?vue&type=style&index=0&id=1145581b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1145581b",
  null
  
)

export default component.exports